import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomCheckboxGroup from "../../../../components/CustomCheckboxGroup";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomUpload from "../../../../components/CustomUpload";
import CustomSelect from "../../../../components/Select/Select";
import { getPetsCompliantSummaryWoLoader } from "../../../../redux/reducers/petSlice";
import {
  createTreatmentPlanByApntIdWoLoader,
  deletePetTreatmentPlanByIdWoLoader,
  getTreatmentPlansWoLoader,
  updateTreatmentPlanByIdWoLoader,
  uploadFilesAndGetUrlWoLoader,
} from "../../../../redux/reducers/planSlice";
import { addIcon, delBtn } from "../../../../util/CommonIconStyle";
import { urlToFile } from "../../../../util/function";
import { canWriteModule } from "../../../../util/roleModuleAccess";
import FilesWithCloseButton from "./FilesWithCloseButton";

const PetTreatmentPlan = () => {
  const dispatch = useDispatch();
  const canManageDashboard = canWriteModule("dashboard");
  const location = useLocation();
  const clinicPlanFetchedRef = useRef(false);
  const [selModVsble, setSelModVsble] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [planValues, setPlanValues] = useState({});
  const [delModVsble, setDelModVsble] = useState(false);
  const [discardModVsble, setDiscardModVsble] = useState(false);
  const { treatmentPlans } = useSelector((state) => state?.plan);
  const { appointment } = location.state || {};
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  useEffect(() => {
    if (clinicPlanFetchedRef.current) return;
    clinicPlanFetchedRef.current = true;
    dispatch(getTreatmentPlansWoLoader());
  }, [dispatch]);

  const callApi = () => {
    dispatch(
      getPetsCompliantSummaryWoLoader(
        reqDet?.appointment?.appointmentId ??
          appointment?.appoinment?.appointmentId,
      ),
    );
  };

  const getPlans = () => {
    return treatmentPlans?.map((pln) => ({
      ...pln,
      name: pln?.planName,
      value: pln?.planId,
    }));
  };

  const onSelectPlan = (pln) => {
    setSelectedPlan(pln);
    let reqObj = {};
    pln?.treatmentPlanDetails?.forEach((li) => {
      reqObj = { ...reqObj, [li?.question]: null };
    });
    setPlanValues(reqObj);
  };

  const handleChange = (name, value) => {
    setPlanValues({ ...planValues, [name]: value });
  };

  const onUploadFile = (ques, e) => {
    const fileList = e?.target?.files;
    let fileLists =
      planValues?.[ques]?.length > 0 ? [...planValues?.[ques]] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setPlanValues({ ...planValues, [ques]: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleImageRemove = (name, ind) => {
    const reqFiles = planValues?.[name]?.filter((fl, i) => i !== ind);
    setPlanValues({ ...planValues, [name]: reqFiles });
  };

  const onCloseMod = () => {
    setPlanValues({});
    setSelModVsble(false);
    setSelectedPlan(null);
  };

  const handleSave = async () => {
    const appointmentTreatmentPlan = await Promise.all(
      selectedPlan?.treatmentPlanDetails?.map(async (li) => {
        const reqObj = {
          question: li?.question,
          answer: Array.isArray(planValues?.[li?.question])
            ? planValues?.[li?.question]
            : [planValues?.[li?.question]],
          questionId: li?.questionId,
          questionType: li?.questionType,
        };
        if (li?.questionType === "fileupload") {
          delete reqObj.answer;
          const filesList = planValues?.[li?.question] || [];
          if (filesList?.length > 0) {
            const form = new FormData();
            // Create an array of promises for all files (convert remote to File)
            const filePromises = filesList?.map(async (fle) => {
              if (fle?.file) {
                return fle?.file; // Local File
              } else {
                return await urlToFile(fle?.previewUrl); // Remote File
              }
            });
            // Wait for all file promises to resolve
            const finalFiles = await Promise.all(filePromises);
            // Append all files to the form
            finalFiles?.forEach((file) => {
              form.append("files", file);
            });
            const res = await dispatch(uploadFilesAndGetUrlWoLoader(form));
            if (res?.payload) {
              reqObj.files = res.payload.data?.data;
            }
          }
        }
        return reqObj;
      }),
    );
    const data = {
      planId: selectedPlan?.planId,
      planName: selectedPlan?.planName,
      appointmentTreatmentPlan,
    };
    if (selectedPlan?.id) {
      dispatch(
        updateTreatmentPlanByIdWoLoader({ id: selectedPlan?.id, data }),
      ).then((res) => {
        if (res?.payload) {
          onCloseMod();
          callApi();
        }
      });
    } else {
      dispatch(
        createTreatmentPlanByApntIdWoLoader({
          apntId: reqDet?.appointment?.appointmentId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) {
          onCloseMod();
          callApi();
        }
      });
    }
  };

  const handleDelete = (pln) => {
    setSelectedPlan(pln);
    setDelModVsble(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedPlan(null);
  };

  const onCofirmDelete = () => {
    if (!selectedPlan?.id) return;
    dispatch(deletePetTreatmentPlanByIdWoLoader(selectedPlan?.id)).then(
      (res) => {
        if (res?.payload) {
          onCloseDelMod();
          callApi();
        }
      },
    );
  };

  const addEditShow = true;
  // reqDet?.appointment?.appointmentStatus?.toLowerCase() !== "completed" ||
  // (reqDet?.appointment?.appointmentStatus?.toLowerCase() === "completed" &&
  //   !reqDet?.appointment?.lock);

  const handleEdit = (pln) => {
    // if (reqDet?.appointment?.appointmentStatus?.toLowerCase() !== "completed") {
    //   return;
    // }
    const reqPlan = treatmentPlans?.find((tp) => tp?.planId === pln?.planId);

    let reqObj = {};
    pln?.appointmentTreatmentPlan?.forEach((li) => {
      reqObj = {
        ...reqObj,
        [li?.question]:
          li?.questionType === "paragraph" ||
          li?.questionType === "shortAnswer" ||
          li?.questionType === "multipleChoice"
            ? li?.answer?.[0]
            : li?.questionType === "fileupload"
              ? li?.files?.length > 0
                ? li?.files?.map((fle) => ({ file: null, previewUrl: fle }))
                : null
              : li?.answer,
      };
    });
    setPlanValues(reqObj);
    if (reqPlan) {
      setSelectedPlan({
        ...reqPlan,
        id: pln?.id,
        name: reqPlan?.planName,
        value: reqPlan?.planId,
      });
    }
    setSelModVsble(true);
  };

  const onConfirmDiscard = () => {
    setDiscardModVsble(false);
    setSelModVsble(false);
    setSelectedPlan(null);
  };

  const onCloseDiscardMod = () => {
    setDiscardModVsble(false);
  };

  return (
    <>
      <div className="ph20 mt10">
        {!selModVsble ? (
          <>
            <div className="flex-row-ali-cen ph20">
              <div className="w60Per">
                <Typography className="font-bold blue-color fs12">
                  Name
                </Typography>
              </div>
              <div className="w20Per">
                <Typography className="font-bold blue-color fs12">
                  Date
                </Typography>
              </div>
              <div className="w10Per" />
            </div>
            <div className="blue-hor-split mt5" />
            {reqDet?.treatmentPlas?.map((pln, i) => (
              <div className="flex-row-ali-cen ph20 mt10" key={`pln_${i}`}>
                <div className="w60Per">
                  <Typography
                    className={`txt-semi-bold fs12 ${
                      canManageDashboard
                        ? "blue-color underline cursor"
                        : "gray34"
                    }`}
                    onClick={() => {
                      if (!canManageDashboard) return;
                      handleEdit(pln);
                    }}
                  >
                    {pln?.planName}
                  </Typography>
                </div>
                <div className="w20Per">
                  <Typography className="font-medium fs12 gray34">
                    {moment(new Date(pln?.createdDate)).format("DD MMM YYYY")}
                  </Typography>
                </div>
                <div className="w10Per">
                  {canManageDashboard && addEditShow ? (
                    <div className="cursor" onClick={() => handleDelete(pln)}>
                      <div className="flex-center">
                        <DeleteOutlineIcon sx={delBtn} />
                      </div>
                      <Typography className="red3 fs8 txt-semi-bold text-align-center">
                        Delete
                      </Typography>
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
            {canManageDashboard && addEditShow ? (
              <div
                className="flex-row-ali-cen mt20 cursor"
                onClick={() => setSelModVsble(true)}
              >
                <div className="flex-center plus-icon">
                  <AddIcon sx={addIcon} />
                </div>
                <Typography className="blue-color fs16 ml5 font-bold">
                  Add
                </Typography>
              </div>
            ) : null}
          </>
        ) : (
          <>
            <div className="flex-row-ali-cen">
              <Typography className="blue-color fs14 txt-semi-bold">
                Name :
              </Typography>
              <div className="w70Per ml20">
                <CustomSelect
                  list={getPlans()}
                  select
                  search
                  value={selectedPlan}
                  handleChange={(e, value) => onSelectPlan(value)}
                  disabled={selectedPlan?.id}
                />
              </div>
              {!selectedPlan ? (
                <div className="flex1-end">
                  <div>
                    <CustomButton
                      text="Discard"
                      redBtn
                      smallBtn
                      onClick={() => setDiscardModVsble(true)}
                    />
                  </div>
                </div>
              ) : null}
            </div>
            {selectedPlan?.treatmentPlanDetails?.map((ques, i) => (
              <div key={`${ques?.questionId} ${i}`} className="mv5">
                <Typography className="font-medium fs16 black">
                  {i + 1}) {ques?.question}
                </Typography>
                <div className="mv5">
                  {ques?.questionType === "shortAnswer" ||
                  ques?.questionType === "paragraph" ? (
                    <CustomTextField
                      fullWidth
                      value={planValues?.[ques?.question]}
                      multiline={ques?.questionType === "paragraph"}
                      handleChange={(e) =>
                        handleChange(ques?.question, e?.target?.value)
                      }
                    />
                  ) : ques?.questionType === "multipleChoice" ? (
                    <CustomCheckbox
                      radios={ques?.answer?.map((rd) => ({
                        label: rd,
                        value: rd,
                      }))}
                      defaultValue={planValues?.[ques?.question]}
                      radio
                      onChange={(e) => {
                        handleChange(ques?.question, e?.target?.value);
                      }}
                      isRow={false}
                    />
                  ) : ques?.questionType === "checkboxes" ? (
                    <div className="ml10">
                      <CustomCheckboxGroup
                        list={ques?.answer?.map((li) => ({
                          label: li,
                          value: li,
                        }))}
                        value={planValues?.[ques?.question] ?? []}
                        onChange={(e) => {
                          handleChange(ques?.question, e);
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      {planValues?.[ques?.question]?.length > 0 ? (
                        <div className="mt20">
                          <FilesWithCloseButton
                            files={planValues?.[ques?.question]}
                            onClickFile={(i, file) =>
                              handleImageRemove(ques?.question, i)
                            }
                          />
                        </div>
                      ) : null}
                      <div className="mt20">
                        <CustomUpload
                          onUploadFile={(e) => onUploadFile(ques?.question, e)}
                          multipleNew
                          multiFiles
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
            <div className="flex-row-ali-cen mt10">
              {selectedPlan && (
                <div className="flex1-end">
                  <div>
                    <div>
                      <CustomButton text="Save" smallBtn onClick={handleSave} />
                    </div>
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Discard"
                      redBtn
                      smallBtn
                      onClick={() => setDiscardModVsble(true)}
                    />
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the Protocol?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="Yes" redBtn onClick={onCofirmDelete} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={discardModVsble}
        onClose={onCloseDiscardMod}
        header="Discard"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to discard the Protocol?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton
              text="Yes"
              redBtn
              onClick={onConfirmDiscard}
              smallBtn
            />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDiscardMod} smallBtn />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PetTreatmentPlan;
